// extracted by mini-css-extract-plugin
export default {"root":"FpU5cMpwyfow3tKWmF5g","title":"SBEQ9y08KGb7Cq402TZV","content":"HMzrnksqTogrz8Jx1QQx","icon":"n1PagOcIPBTBtl7gKDwK","quality":"VZuiCdhtNeIRydaxqQbQ"};